<div class="container p-0" *ngIf="textoInfo">
    <p>{{textoInfo}}</p>
</div>
<div class="container p-0" *ngIf="urlImagen">
    <img [src]="urlImagen"/>
</div>